import { render, staticRenderFns } from "./MediaAccreditationPassForm.vue?vue&type=template&id=465ac82e&scoped=true"
import script from "./MediaAccreditationPassForm.vue?vue&type=script&lang=js"
export * from "./MediaAccreditationPassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ac82e",
  null
  
)

export default component.exports